module.exports = __webpack_public_path__ + "media/diverticulitis.2f2e9365.wav";